var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"element",staticClass:"video"},[(_vm.display)?_c('iframe',{attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.url,"frameborder":"0","allow":"autoplay; encrypted-media","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f5c3a12","hasScoped":false,"buble":{"transforms":{}}}!./resources/assets/front/js/components/jj-video/template.html
// module id = 197
// module chunks = 14